<template>
  <AuthLayout>
    <div class="login-view">
      <div class="login-view__switch glass">
        <button type="button" :class="{ active: mode === 'login' }" @click="setMode('login')">Вход</button>
        <button type="button" :class="{ active: mode === 'register' }" @click="setMode('register')">Регистрация</button>
      </div>

      <LoginForm
        v-if="mode === 'login'"
        v-model="loginForm"
        :loading="loading"
        :error="error"
        @submit="submitLogin"
      />

      <RegisterForm
        v-else
        v-model="registerForm"
        :step="registerStep"
        :loading="loading"
        :error="error"
        :success="success"
        :clubs="clubs"
        @start="startRegister"
        @send-code="sendRegisterCode"
        @confirm-code="confirmRegisterCode"
        @resend-code="sendRegisterCode"
        @back="goRegisterBack"
      />
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from '../components/auth/AuthLayout.vue';
import LoginForm from '../components/auth/LoginForm.vue';
import RegisterForm from '../components/auth/RegisterForm.vue';
import { isValidRuPhone } from '../utils/ruPhone';

export default {
  name: 'LoginView',
  components: { AuthLayout, LoginForm, RegisterForm },
  data() {
    return {
      mode: 'login',
      registerStep: 1,
      success: '',
      loginForm: {
        phone: '',
        password: '',
      },
      registerForm: {
        full_name: '',
        email: '',
        password: '',
        password_repeat: '',
        phone: '',
        verification_method: 'call',
        method: 'call',
        code: '',
        club_id: '',
        consent: true,
      },
    };
  },
  computed: {
    loading() {
      return this.$store.getters['auth/loading'];
    },
    error() {
      return this.$store.getters['auth/error'];
    },
    clubs() {
      return this.$store.getters['clubs/clubs'];
    },
  },
  watch: {
    mode() {
      this.clearMessages();
    },
  },
  async mounted() {
    await this.$store.dispatch('clubs/fetchClubs');
  },
  methods: {
    setMode(mode) {
      this.mode = mode;
    },
    clearMessages() {
      this.success = '';
      this.$store.dispatch('auth/clearError');
    },
    validatePhone(value) {
      return isValidRuPhone(value);
    },
    setFormError(message) {
      this.$store.commit('auth/SET_ERROR', message);
      return { ok: false, message };
    },
    validateRegisterFirstStep() {
      const form = this.registerForm;

      if (!String(form.full_name || '').trim()) {
        return this.setFormError('Введите имя и фамилию.');
      }

      if (!String(form.email || '').trim()) {
        return this.setFormError('Введите email.');
      }

      if (!String(form.password || '')) {
        return this.setFormError('Введите пароль.');
      }

      if (String(form.password).length < 6) {
        return this.setFormError('Пароль должен быть не короче 6 символов.');
      }

      if (form.password !== form.password_repeat) {
        return this.setFormError('Пароли не совпадают.');
      }

      if (!form.consent) {
        return this.setFormError('Нужно принять политику и согласие.');
      }

      return { ok: true };
    },
    async submitLogin() {
      this.clearMessages();

      if (!this.validatePhone(this.loginForm.phone)) {
        this.setFormError('Введите корректный номер телефона.');
        return;
      }

      if (!this.loginForm.password) {
        this.setFormError('Введите пароль.');
        return;
      }

      const result = await this.$store.dispatch('auth/login', this.loginForm);
      if (result?.ok) {
        await this.$store.dispatch('clubs/fetchClubs', { force: true });
        this.$router.push('/');
      }
    },
    async startRegister() {
      this.clearMessages();

      const validation = this.validateRegisterFirstStep();
      if (!validation.ok) return;

      const result = await this.$store.dispatch('auth/registerStart', this.registerForm);
      if (result?.ok) {
        this.registerStep = 2;
      }
    },
    async sendRegisterCode() {
      this.clearMessages();

      if (!this.validatePhone(this.registerForm.phone)) {
        this.setFormError('Введите корректный номер телефона.');
        return;
      }

      const method = ['call', 'telegram'].includes(this.registerForm.verification_method)
        ? this.registerForm.verification_method
        : 'call';

      this.registerForm.verification_method = method;
      this.registerForm.method = method;

      const result = await this.$store.dispatch('auth/registerSendCode', this.registerForm);
      if (result?.ok) {
        this.success = result.message || 'Код отправлен.';
        this.registerStep = 3;
      }
    },
    async confirmRegisterCode() {
      this.clearMessages();

      const code = String(this.registerForm.code || '').replace(/\D/g, '');

      if (code.length !== 4) {
        this.setFormError('Введите 4 цифры кода подтверждения.');
        return;
      }

      this.registerForm.code = code;

      const result = await this.$store.dispatch('auth/registerConfirmCode', this.registerForm);
      if (result?.ok) {
        this.success = 'Регистрация прошла успешно.';
        await this.$store.dispatch('clubs/fetchClubs', { force: true });
        this.$router.push('/');
      }
    },
    goRegisterBack() {
      this.clearMessages();
      this.registerStep = Math.max(1, this.registerStep - 1);
    },
  },
};
</script>

<style scoped>
.login-view__switch {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 8px;
  border-radius: 22px;
  margin-bottom: 22px;
}

.login-view__switch button {
  min-height: 52px;
  border-radius: 16px;
  border: 0;
  background: transparent;
  color: var(--text-soft);
  font-weight: 800;
  cursor: pointer;
}

.login-view__switch button.active {
  background: rgba(255, 255, 255, 0.08);
  color: var(--text);
}
</style>